<template>
  <transition name="fade">
    <div class="toast" v-if="toast.show">
      <p class="toast-main">{{ toast.text }}</p>
    </div>
  </transition>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'toast',
  computed: {
    ...mapState({
      toast: state => state.support.toast,
    }),
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/support.scss';
@import '../../assets/scss/platform-support.scss';
.toast {
  @include size(485, 217);
  padding: 0 50px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.8);
  opacity: 0.8;
  display: table;
  border-radius: 5px;
  z-index: 999;
  &-main {
    width: 100%;
    height: 100%;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    color: #f3f3f3;
    font-size: 30px;
    word-break: break-all;
  }
}
</style>
